import React, { useState } from 'react'
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import social from "../assets/social.png"
import { BiLike } from "react-icons/bi"
import { MdKeyboardArrowLeft } from "react-icons/md"
import arrow from "../assets/larrow.png"
import one from "../assets/ones.png"
import two from "../assets/twos.png"
import three from "../assets/threes.png"


function ProfileModal() {
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        // background: "rgba(0, 0, 0, 0.2)",
        backdropFilter: "blur(2.5px)",
        border: "none",
        boxShadow: 24,
        borderRadius:"10px"

    }
    return (<>
        <div>
            <button onClick={handleOpen} className='connect_btn' style={{ paddingLeft: "15px", paddingRight: "15px" }}>Connect</button>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Box className="modal_header pt-2 pb-2">
                        <img onClick={handleClose} src={arrow} />
                        <div className="like_div">
                            <img src={social} />
                            <p>Facebook</p>
                        </div>
                        <Box className="likes_div" >
                            <BiLike style={{ color: "white" }} />
                            <p>Like 10K</p>
                        </Box>


                    </Box>
                    <div className='d-flex justify-content-around gap-2 flex-wrap mt-5 mb-3'>
                        <div>
                            <div className='modal_img_div'>
                                <img src={three} />
                            </div>
                            <p className='modal_line'>Page</p>
                        </div>
                        <div>
                            <div className='modal_img_div'>
                                <img src={two} />
                            </div>
                            <p className='modal_line'>Location</p>
                        </div>
                        <div>
                            <div className='modal_img_div'>
                                <img src={one} />
                            </div>
                            <p className='modal_line'>Group</p>
                        </div>
                    </div>
                </Box>
            </Modal>
        </div>

    </>

    )
}

export default ProfileModal